import $api from "../../api/$api";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";
import {
  TDataToken,
  TCreateInterviewPayload,
  TDeleteInterviewPayload,
  TUpdateInterviewPayload,
  TQueries,
  GetInterviewResponse
} from "./type";
import { AxiosResponse } from "axios";

// Create
export const createInterview = (
  data: TDataToken,
  payload: TCreateInterviewPayload
) => {
  return $api
    .post("refactor/interview", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateInterview = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TCreateInterviewPayload>
) => {
  return useMutation({
    mutationFn: (payload: TCreateInterviewPayload) =>
      createInterview(data, payload),
    ...config
  });
};

// Get
export const getInterviews = (
  data: TDataToken,
  queries: TQueries
): Promise<AxiosResponse<GetInterviewResponse[]>> => {
  return $api
    .get(`interview-details`, {
      token: data.accessToken,
      params: { ...queries }
    })
    .then((response) => {
      return response;
    });
};

export const useGetInterviews = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["interviews", queries],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getInterviews(data, queries),
    ...(config as UseQueryOptions<any>)
  });
};

// Delete
export const deleteInterview = (
  data: TDataToken,
  payload: TDeleteInterviewPayload
) => {
  return $api
    .delete("refactor/interview", {
      data: { ...payload },
      token: data.accessToken
    })
    .then((response) => {
      return response;
    });
};

export const useDeleteInterview = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TDeleteInterviewPayload>
) => {
  return useMutation({
    mutationFn: (payload: TDeleteInterviewPayload) =>
      deleteInterview(data, payload),
    ...config
  });
};

//Update
export const updateInterview = (
  data: TDataToken,
  payload: TUpdateInterviewPayload
) => {
  return $api
    .put("refactor/interview", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateInterview = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TUpdateInterviewPayload>
) => {
  return useMutation({
    mutationFn: (payload: TUpdateInterviewPayload) =>
      updateInterview(data, payload),
    ...config
  });
};
